import React from "react"
import DiamondIcon from '@mui/icons-material/Diamond';

const SquareActivo = ({ac, handleDragStart, lvNro}) => {

    return <div key={ac.name} className={`activoDiv ${lvNro == 1 ? 'activoInNivel1' : lvNro == 2 ? 'activoInNivel2' : lvNro == 3 ? 'activoInNivel3' : lvNro == 4 ? 'activoInNivel4' : 'activoInNivel5'}`} draggable={true} onDragStart={(e)=>handleDragStart(ac, lvNro)}>
        <h6>{ac.name}</h6>
        {(ac.imageURL != null) ? <img draggable={false} key={`image${ac.codActivo}`} src={ac.imageURL}/> : <DiamondIcon className="rrIcon"/>}
        {(ac.actStatus != undefined && ac.actStatus == 'FSERV') && <label className="fServLabel">Fuera de Servicio</label>}
    </div>

}

export default SquareActivo;